import React from "react";
import QuestionDetail from "../../Components/Question/QuestionDetail";

function Question() {
  return (
    <div>
      <QuestionDetail />
    </div>
  );
}

export default Question;
